export const STORAGE_KEYS = {
  SELECTED_PLATFORMS: 'portfolio_selected_platforms',
  SELECTED_TRANSACTION_PLATFORMS: 'portfolio_selected_transaction_platforms',
  SELECTED_QUICK_DATE: 'portfolio_selected_quick_date',
  TRANSACTIONS_FROM_DATE: 'portfolio_transactions_from_date',
  TRANSACTIONS_UNTIL_DATE: 'portfolio_transactions_until_date',
  SHOW_ACTIVE_ONLY: 'portfolio_show_active_only',
  SELECTED_SUMMARY_PLATFORMS: 'portfolio_selected_summary_platforms',
  SUMMARY_CHART_RANGE: 'portfolio_summary_chart_range',
  SUMMARY_CHART_MODE: 'portfolio_summary_chart_mode',
  SUMMARY_CHART_HIDDEN: 'portfolio_summary_chart_hidden',
  SUMMARY_CALENDAR_DAY: 'portfolio_summary_calendar_day',
  SUMMARY_INTERVAL: 'portfolio_summary_interval',
  PRICE_CHANGE_PERIOD: 'portfolio_price_change_period',
  SUMMARY_FILTERS_OPEN: 'portfolio_summary_filters_open',
  INSTRUMENTS_FILTERS_OPEN: 'portfolio_instruments_filters_open',
  TRANSACTIONS_FILTERS_OPEN: 'portfolio_transactions_filters_open',
  ETF_FILTERS_OPEN: 'portfolio_etf_filters_open',
  ETF_BREAKDOWN_TAB: 'portfolio_etf_breakdown_tab',
  ETF_BREAKDOWN_VIEW: 'portfolio_etf_breakdown_view',
  DIVERSIFICATION_BREAKDOWN_TAB: 'portfolio_diversification_breakdown_tab',
  DIVERSIFICATION_BREAKDOWN_VIEW: 'portfolio_diversification_breakdown_view',
  BENCHMARK_COMPARE: 'portfolio_benchmark_compare',
} as const
